import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService, ConfirmationDialogConfig } from '../../services/modal.service';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  standalone: false,
})
export class ConfirmationDialogComponent implements OnInit {
  config!: ConfirmationDialogConfig;

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.modalService.dialogData$.subscribe((data) => {
      if (data) {
        this.config = {
          title: data.title || 'Подтверждение',
          message: data.message,
          confirmText: data.confirmText || 'Да',
          cancelText: data.cancelText || 'Отмена',
          type: data.type || 'warning',
        };
      }
    });
  }

  onConfirm(): void {
    this.activeModal.close(true);
  }

  onCancel(): void {
    this.activeModal.close(false);
  }
}
